// Matches the same "static file" heuristic the headless route middleware
// uses to decide a URL isn't a CMS page (e.g. Umbraco media like .pdf/.jpg).
// Links to these must bypass Vue Router's client-side navigation, otherwise
// the SPA transition never issues a real request for the file and the page
// body is left blank.
const MEDIA_ASSET_PATTERN = /\.[a-zA-Z]{1,4}$/;

export function isMediaAssetUrl ( url: string | null | undefined ): boolean {
  if ( !url ) {
    return false;
  }

  // Strip query string/fragment and any trailing slash before testing, so
  // media URLs with cache-busting params or a trailing slash (added by a
  // CDN/reverse proxy on hosted environments) are still recognised.
  const path = url.split( /[?#]/ )[0].replace( /\/+$/, "" );

  return MEDIA_ASSET_PATTERN.test( path );
}
